import { connect } from 'react-redux';
import { fetchTopSpotters } from '../../actions/spotters';
import TopSpottersList from './TopSpottersList';

function mapStateToProps({ spotters }, ownProps) {
  const { stationId } = ownProps;
  const topSpotters = spotters.spottersByStationId[stationId] || [];

  return {
    isFetching: spotters.isFetching,
    topSpotters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTopSpotters: stationId => dispatch(fetchTopSpotters(stationId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TopSpottersList);
